import { CustomerModel } from "@crypto-payment-gateway/models"
import { FiatParty, TableCustomer, TableMovementType } from "../types"
import { convertToTime, createErrorTime } from "../utils"
import {
	findDisplayNameAndImgForBankInJson,
	getPspOrBankId,
} from "../../../../../lib/utils"

export const mapCustomersDataToTableCustomers = (
	customers: CustomerModel[] = []
): TableCustomer[] => {
	return customers.map((customer) => ({
		id: customer.customer_id,
		name: customer.name,
		customer_id: customer.customer_id,
		alias: customer.alias || customer.customer_id,
		bank_info: customer.bank_info,
		balance: customer.balance,
		time: convertToTime(customer.creation_timestamp) ?? createErrorTime(),
		lastModifiedDateTime: convertToTime(customer.last_modified_timestamp),
		creationDateTime: convertToTime(customer.creation_timestamp),
		contact_info: { email: customer.contact?.email || "" },
		type: "INBOUND" as TableMovementType,
		status: "ACTIVE" as const,
		amount: "0",
        currency: "ARS",
		tax: undefined,
		payment_id: undefined,
		tableView: "customers",
		...getPartiesFromCustomer(customer),
	}))
}

export const getPartiesFromCustomer = (
	customer: CustomerModel
): { sender: FiatParty; recipient: FiatParty } => {
	let bankEntity: FiatParty["bank_entity"] = undefined

	const address = customer.bank_info.cvu
	if (address) {
		const [entityId, entityType] = getPspOrBankId(address)
		const { bank_img, bank_name } = findDisplayNameAndImgForBankInJson(
			entityId ?? ""
		)
		bankEntity = {
			entity_type: entityType === "psp_id" ? "psp" : ("bank" as const),
			id: entityId,
			img: bank_img,
			name: bank_name,
		}
	}

	return {
		sender: {
			cvu: customer.bank_info.cvu,
			alias: customer.bank_info.alias,
			bank_entity: bankEntity,
			type: "fiat",
		},
		recipient: {
			alias: customer.alias,
			cvu: "",
			type: "fiat",
		},
	}
}
